import { render, staticRenderFns } from "./switchChat.vue?vue&type=template&id=f4ab11ac&scoped=true&"
import script from "./switchChat.vue?vue&type=script&lang=js&"
export * from "./switchChat.vue?vue&type=script&lang=js&"
import style0 from "./switchChat.vue?vue&type=style&index=0&id=f4ab11ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ab11ac",
  null
  
)

export default component.exports